import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";

import { Modal } from "bootstrap-vue";
import { Watch } from "vue-property-decorator";

import { Task, TaskDataStore, TaskLifecycleStates } from '@skinsoft/entity'
import { UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC } from "../../../busTopics";

@Component({
    props: ['task', 'targetLifecycle'],
    template: require('./advance-task-modal.html')
})
export class AdvanceTaskModal extends ReactiveVue {
    public $refs: {
        modal: Modal
    }
    public mounted = false
    public canBeClosed = false;
    public $taskDataStore: TaskDataStore;

    public task: Task;
    public targetLifecycle: TaskLifecycleStates;

    public open() {
        this.$refs.modal.show();
    }

    public onShow() {
        this.mounted = true
    }

    public onHide() {
        this.canBeClosed = false;
        this.mounted = false;
    }

    private get message() {
        switch (this.targetLifecycle) {
            case TaskLifecycleStates.IN_PROGRESS:
                return this.$t('advanceTask.modal.startTask')
            case TaskLifecycleStates.PLANNED:
                return this.$t('advanceTask.modal.replanTask')
            default:
                return this.$t('advanceTask.modal.terminateTask')
        }
    }

    public async advance() {
        await this.$taskDataStore.transitionTask(this.task, this.targetLifecycle)
        this.emitOnBus(UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC)
        this.$emit('refresh')
        this.onHide()
    }

    @Watch('mounted')
    private onMountedChange(value: boolean) {
        this.$emit('mounted', value);
    }
}